import React, { useState, useEffect } from "react";
import { useSelector} from "react-redux";
import { Typography, Grid } from "@material-ui/core";
import { store } from "../../../../helpers/store";
import { makeStyles } from "@material-ui/core/styles";
import { adminService } from "../../../../services/admin.service";
import { useHistory } from "react-router-dom";
import { routePaths } from "../../../config/route-paths";
import Backlink from "../../../common/e_backLink/e_back_link"
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    blackColor: {
      fontSize: '0.875rem'
    },
    headerColor:{
        color : theme.palette.ePrimary?.base,
    },
  }));


  function EnergyPlansHeader(){
    const EnergyPlansClasses = useStyles();
    const [subtitle, setSubTitle] = useState("");
    const {t:EnergyPlansLabels, ready: labelReady} = useTranslation("label-E_SUSTAINABILITY");
    let tenantName = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_NAME);
    let primaryLanguage = useSelector((state) =>state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
    const {t:content, ready: contentReady}=useTranslation("content-E_SUSTAINABILITY");
    const history = useHistory();
      const backCall = (props) => {
        if(props.backToHome){
          history.push(routePaths.HOME)
        } else {
          history.length >= 1 ? history.goBack() : history.push(routePaths.HOME);
        }
    };  

    return(
        <React.Fragment>
            <Grid container direction="row">
                <Grid item xs={12}>
                    <Backlink />
                </Grid>
                <Grid item>
                {
                  labelReady?
                <Typography
                  variant="h5" align="left" 
                  className={EnergyPlansClasses.headerColor}>
                  <b>{EnergyPlansLabels("E_SUSTAINABILITY_TITLE")}</b>
                </Typography>
                : <Skeleton />
                }
              </Grid>
       </Grid>
       {
        contentReady?
        <Typography
          align="left"
          variant="subtitle2"
          dangerouslySetInnerHTML={{
            __html: content("E_SUSTAINABILITY_SUBTITLE").answer?.replaceAll("<TENANT_NAME>", tenantName),
          }}
        ></Typography> : <Skeleton />
       }
    </React.Fragment>
    );
  }

  export default EnergyPlansHeader;